module.exports = __webpack_public_path__ + "img/icon-success.73d3537d.svg";